import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const Container = dynamic(() => import('./Container'));

const ContainerConfig = {
  name: 'Container',
  canHaveChildren: true,
  defaultStyles: {
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: 'var(--spacing-regular)',
    paddingRight: 'var(--spacing-regular)',
    marginTop: '0',
    marginBottom: '0',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: 'var(--container-default)',
    width: '100%',
  },
};

Builder.registerComponent(Container, ContainerConfig);
